import axios from "axios";
import '../loader.css';
import { useEffect } from "react";
export default function MRIQueue({ cases }) {
    const waiting = cases.filter(c => c.status === "PAYMENT_DONE");
    const scanning = cases.filter(c => c.status === "SCANNING");
    const done = cases.filter(c => c.status === "SCAN_COMPLETED");
    console.log("Scanning: ", scanning)

    function updatecase2(phone_number) {
        axios.patch(`${process.env.REACT_APP_API_URL}/cases/scanning`, { phone_number }).then((res) => {
            console.log(res.data)
            alert("Scan started!");
            window.location.reload();
        }).catch(err => {
            console.log(err.message)
        })
    }

    function updatecase3(phone_number) {
        axios.patch(`${process.env.REACT_APP_API_URL}/cases/scan_complete`, { phone_number }).then((res) => {
            console.log(res.data)
            alert("Scan completed!");
            window.location.reload();
        }).catch(err => {
            console.log(err.message)
        })
    }
    useEffect(() => {
        document.querySelector(".queue-link").classList.toggle('on', true)
    }, [])
    return (
        <>

            <div>
                <section className="head">
                    <div class="loader"></div>
                    <h3>Waiting</h3>
                </section>

                {
                    waiting.length > 0 ? (<section className="card-container">
                        {waiting.map(c => (
                            <div key={c.phone_number} className="card">
                                <p><span>ID: </span>{c.patient_id}</p>
                                <p><span>Phone: </span>{c.phone_number}</p>
                                <p><span>Scan: </span>{c.modality}  {c.body}</p>
                                <p><span>Name: </span>{c.first_name} {c.last_name}</p>
                                <button size="sm" onClick={() => updatecase2(c.phone_number)}>Start</button>
                            </div>

                        ))}

                    </section>) : (<div>No patients waiting</div>)
                }
            </div>


            <div>
                <div>
                    <section className="head">
                        <div class="loader"></div>
                        <h3>In Progress</h3>
                    </section>
                    {scanning ? (
                        <section className="card-container">


                            {
                                scanning.map(c => (<div className="card">
                                    <p><span>ID: </span>{c.patient_id}</p>
                                    <p><span>Phone: </span>{c.phone_number}</p>
                                    <p><span>Scan: </span>{c.modality} {c.body}</p>
                                    <p><span>Name: </span>{c.first_name} {c.last_name}</p>
                                    <button onClick={() => updatecase3(c.phone_number)}>
                                        Complete
                                    </button>
                                </div>))
                            }



                        </section>) : (<div>No patients scanning</div>)}

                </div>
            </div>

            <div>
                <div>
                    <h3>Completed</h3>
                    {done.length > 0 ? (<section className="card-container">
                        {done.map(c => (
                            <div key={c.patient_id} className="card">
                                <p><span>ID: </span>{c.patient_id}</p>
                                <p><span>Phone: </span>{c.phone_number}</p>
                                <p><span>Scan: </span>{c.modality}  {c.body}</p>
                                <p><span>Name: </span>{c.first_name} {c.last_name}</p>
                            </div>
                        ))}
                    </section>) : (<div>No patients done</div>)}

                </div>
            </div>
        </>
    );
}